import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import { paymentHistoryQueryKeys } from "../query-keys/payment-history.query-keys";
import {
  Paginated,
  PaymentHistoryFilters,
  PaymentHistoryResponse,
  QueryArgs,
  Sortable,
} from "@ac-expo/api-types";

const getPaymentHistory = async (
  filters: Sortable<Paginated<PaymentHistoryFilters>>
) => {
  const { data } = await privateAxios.get<PaymentHistoryResponse>(
    `/payment-history`,
    { params: filters }
  );

  return data;
};

export const useGetPaymentHistoryQuery = (
  filters: Sortable<Paginated<PaymentHistoryFilters>>,
  options?: QueryArgs<PaymentHistoryResponse>
) => {
  return useQuery({
    queryKey: paymentHistoryQueryKeys.lists(filters),
    queryFn: () => getPaymentHistory(filters),
    ...options,
  });
};
